export default  {
  validate: {
    email: (rule, value, callback) => {
      // eslint-disable-next-line no-useless-escape
      const regexp = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      if (value === '') {
        callback(new Error('请输入邮箱！'));
      } else if (!(regexp.test(value))) {
        callback(new Error('邮箱格式不正确！'));
      } else {
        callback();
      }
    },
    // 字符验证，只能包含中文、英文、数字、下划线等字符。
    stringCheck: (rule, value, callback) => {
      // const regexp = /^[a-zA-Z0-9_*：:【】（）￥、\s\+\.\-()+\u4e00-\u9fa5]+$/;
      const regexp = /^[a-zA-Z0-9]{8,30}$/;
      if (value === '') {
        callback(new Error('请输入名称！'));
      } else if (!(regexp.test(value))) {
        callback(new Error('只能包含字母、数字等字符'));
      } else {
        callback();
      }
    },
    phone: (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码！'));
      } else if (!(/^1[3-9][0-9]{9}$/.test(value))) {
        callback(new Error('手机号码格式不正确！'));
      } else {
        callback();
      }
    },
  },
};


// WEBPACK FOOTER //
// ./src/utils/tools.js